import ResourceRightRail from './ResourceRightRail';

export default ResourceRightRail;
